// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/login/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktopPage{
    position: relative;
    /*padding: 15px 36px;*/
    width: 100%;
    height: 100vh;
}

.desktopPage_background{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    max-height: 300px;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
}
         
.desktopPage_wrapper{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fffb;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0px 12px;
}
/*
.desktopPage_doubleCollapser{
    display: grid;
    grid-template-columns: 1fr 1fr;
    transition-duration: 5400ms;
    transition-timing-function: linear;
    height: 200px;
}

.desktopPage_doubleCollapser--both{
    grid-template-columns: 1fr 1fr;
}

.desktopPage_doubleCollapser--left{
    grid-template-columns: 0fr 1fr;
}

.desktopPage_doubleCollapser--right{
    grid-template-columns: 1fr 0fr;
}

.desktopPage_doubleCollapser_left{
    min-width: 50px;
    background: #f99;
    overflow: hidden;
}

.desktopPage_doubleCollapser_right{
    min-width: 50px;
    background: #99f;
    overflow: hidden;
}*/

.desktopPage_doubleCollapser{
    display: flex;
    height: 100px;
}

.desktopPage_doubleCollapser_side{
    display: flex;
    transition-duration: 400ms;
    /*transition-timing-function: linear;*/
    width: 100%;
    position: relative;
    transition-delay: 400ms;
}

.desktopPage_doubleCollapser_left{
    /*min-width: 50px;*/
    background: #f99;
    overflow: hidden;
}

.desktopPage_doubleCollapser_right{
    /*min-width: 50px;*/
    background: #09f;
    overflow: hidden;
}

.desktopPage_doubleCollapser_content_holder_zero{
    position: absolute;
    right: 0px;
    width: 0;
}

.desktopPage_doubleCollapser_content_holder{
    width: 30px;
    background-color: #9f9;
}

.desktopPage_doubleCollapser--both{
    .desktopPage_doubleCollapser_left{
        width: 100%;
        transition-delay: 0ms;
    }
    
    .desktopPage_doubleCollapser_right{
        width: 100%;
        transition-delay: 0ms;
    }
}

.desktopPage_doubleCollapser--left{
    .desktopPage_doubleCollapser_left{
        transition-delay: 0ms;
    }
    
    .desktopPage_doubleCollapser_right{
        width: 30px;
    }
}

.desktopPage_doubleCollapser--right{
    .desktopPage_doubleCollapser_left{
        width: 30px;
    }
    
    .desktopPage_doubleCollapser_right{
        transition-delay: 0ms;
    }
    
    .desktopPage_doubleCollapser_content_holder_zero{
        right: 30px;
    }
}

.desktopPage_doubleCollapser_content{
    width: 100%;
    overflow: hidden;
    border: 1px solid #000;
    background-color: #0009;
    position: absolute;
    transition-duration: 400ms;
    /*transition-timing-function: linear;*/
    transition-delay: 200ms;
}

.desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{
    right: 0%;
}

.desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{
    left: 0%;
}

.desktopPage_doubleCollapser--left{
    .desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{
        right: 0%;
    }
    
    .desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{
        left: 100%;
        transition-delay: 0ms;
    }
}

.desktopPage_doubleCollapser--right{
    .desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{
        right: 100%;
        transition-delay: 0ms;
    }
    
    .desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{
        left: 0%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/desktopPage/DesktopPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAA0D;IAC1D,iBAAiB;IACjB,sBAAsB;IACtB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;AACrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE;;AAEF;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,sCAAsC;IACtC,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,0BAA0B;IAC1B,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":[".desktopPage{\n    position: relative;\n    /*padding: 15px 36px;*/\n    width: 100%;\n    height: 100vh;\n}\n\n.desktopPage_background{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('../../assets/login/background.png');\n    max-height: 300px;\n    background-size: cover;\n    background-position: top center;\n    background-repeat: no-repeat;\n}\n         \n.desktopPage_wrapper{\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background-color: #fffb;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    padding: 0px 12px;\n}\n/*\n.desktopPage_doubleCollapser{\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    transition-duration: 5400ms;\n    transition-timing-function: linear;\n    height: 200px;\n}\n\n.desktopPage_doubleCollapser--both{\n    grid-template-columns: 1fr 1fr;\n}\n\n.desktopPage_doubleCollapser--left{\n    grid-template-columns: 0fr 1fr;\n}\n\n.desktopPage_doubleCollapser--right{\n    grid-template-columns: 1fr 0fr;\n}\n\n.desktopPage_doubleCollapser_left{\n    min-width: 50px;\n    background: #f99;\n    overflow: hidden;\n}\n\n.desktopPage_doubleCollapser_right{\n    min-width: 50px;\n    background: #99f;\n    overflow: hidden;\n}*/\n\n.desktopPage_doubleCollapser{\n    display: flex;\n    height: 100px;\n}\n\n.desktopPage_doubleCollapser_side{\n    display: flex;\n    transition-duration: 400ms;\n    /*transition-timing-function: linear;*/\n    width: 100%;\n    position: relative;\n    transition-delay: 400ms;\n}\n\n.desktopPage_doubleCollapser_left{\n    /*min-width: 50px;*/\n    background: #f99;\n    overflow: hidden;\n}\n\n.desktopPage_doubleCollapser_right{\n    /*min-width: 50px;*/\n    background: #09f;\n    overflow: hidden;\n}\n\n.desktopPage_doubleCollapser_content_holder_zero{\n    position: absolute;\n    right: 0px;\n    width: 0;\n}\n\n.desktopPage_doubleCollapser_content_holder{\n    width: 30px;\n    background-color: #9f9;\n}\n\n.desktopPage_doubleCollapser--both{\n    .desktopPage_doubleCollapser_left{\n        width: 100%;\n        transition-delay: 0ms;\n    }\n    \n    .desktopPage_doubleCollapser_right{\n        width: 100%;\n        transition-delay: 0ms;\n    }\n}\n\n.desktopPage_doubleCollapser--left{\n    .desktopPage_doubleCollapser_left{\n        transition-delay: 0ms;\n    }\n    \n    .desktopPage_doubleCollapser_right{\n        width: 30px;\n    }\n}\n\n.desktopPage_doubleCollapser--right{\n    .desktopPage_doubleCollapser_left{\n        width: 30px;\n    }\n    \n    .desktopPage_doubleCollapser_right{\n        transition-delay: 0ms;\n    }\n    \n    .desktopPage_doubleCollapser_content_holder_zero{\n        right: 30px;\n    }\n}\n\n.desktopPage_doubleCollapser_content{\n    width: 100%;\n    overflow: hidden;\n    border: 1px solid #000;\n    background-color: #0009;\n    position: absolute;\n    transition-duration: 400ms;\n    /*transition-timing-function: linear;*/\n    transition-delay: 200ms;\n}\n\n.desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{\n    right: 0%;\n}\n\n.desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{\n    left: 0%;\n}\n\n.desktopPage_doubleCollapser--left{\n    .desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{\n        right: 0%;\n    }\n    \n    .desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{\n        left: 100%;\n        transition-delay: 0ms;\n    }\n}\n\n.desktopPage_doubleCollapser--right{\n    .desktopPage_doubleCollapser_left .desktopPage_doubleCollapser_content{\n        right: 100%;\n        transition-delay: 0ms;\n    }\n    \n    .desktopPage_doubleCollapser_right .desktopPage_doubleCollapser_content{\n        left: 0%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
